import { normalizeSiteUrl } from "~~/shared/utils/seo/site";

const DEFAULT_APP_URL = "https://app.upfest.net";
const DEFAULT_SUPPORT_EMAIL = "contact@rbyte.eu";
const DEFAULT_CONTACT_EMAIL = "contact@rbyte.eu";
const DEFAULT_LEGAL_EMAIL = "contact@rbyte.eu";
const DEFAULT_LEGAL_PLATFORM_NAME = "Upfest";
const DEFAULT_LEGAL_OPERATOR_NAME = "rByte FlexCo";
const DEFAULT_LEGAL_OPERATOR_ADDRESS = "[TODO: Street + house number]";
const DEFAULT_LEGAL_OPERATOR_CITY = "[TODO: Postal code + city]";
const DEFAULT_LEGAL_OPERATOR_REGISTER_ID =
  "[TODO: Register court + HRB number]";
const DEFAULT_LEGAL_VAT_ID = "[TODO: USt-IdNr., if available]";
const DEFAULT_LEGAL_MANAGING_DIRECTOR = "[TODO: Name]";
const DEFAULT_LEGAL_PHONE = "[TODO: Optional phone]";
const DEFAULT_LEGAL_SUPERVISORY_AUTHORITY =
  "[TODO: Competent supervisory authority]";
const DEFAULT_LEGAL_PRIVACY_EMAIL = "[TODO: legal/contact email]";
const DEFAULT_LEGAL_COURT_PLACE = "[TODO: Jurisdiction / court place]";

function normalizeBaseUrl(value: string | undefined, fallback: string): string {
  const resolved = value && value.trim() ? value.trim() : fallback;
  return resolved.replace(/\/+$/, "");
}

function normalizeEmail(value: string | undefined, fallback: string): string {
  return value && value.trim() ? value.trim() : fallback;
}

export function usePublicUrls() {
  const config = useRuntimeConfig();

  const APP_URL = normalizeBaseUrl(
    config.public.appUrl as string | undefined,
    DEFAULT_APP_URL,
  );
  const SITE_URL = normalizeSiteUrl(
    config.public.siteUrl as string | undefined,
  );
  const SUPPORT_EMAIL = normalizeEmail(
    config.public.supportEmail as string | undefined,
    DEFAULT_SUPPORT_EMAIL,
  );
  const CONTACT_EMAIL = normalizeEmail(
    config.public.contactEmail as string | undefined,
    DEFAULT_CONTACT_EMAIL,
  );
  const LEGAL_EMAIL = normalizeEmail(
    config.public.legalEmail as string | undefined,
    DEFAULT_LEGAL_EMAIL,
  );
  const LEGAL_PLATFORM_NAME = normalizeEmail(
    config.public.legalPlatformName as string | undefined,
    DEFAULT_LEGAL_PLATFORM_NAME,
  );
  const LEGAL_OPERATOR_NAME = normalizeEmail(
    config.public.legalOperatorName as string | undefined,
    DEFAULT_LEGAL_OPERATOR_NAME,
  );
  const LEGAL_OPERATOR_ADDRESS = normalizeEmail(
    config.public.legalOperatorAddress as string | undefined,
    DEFAULT_LEGAL_OPERATOR_ADDRESS,
  );
  const LEGAL_OPERATOR_CITY = normalizeEmail(
    config.public.legalOperatorCity as string | undefined,
    DEFAULT_LEGAL_OPERATOR_CITY,
  );
  const LEGAL_OPERATOR_REGISTER_ID = normalizeEmail(
    config.public.legalOperatorRegisterId as string | undefined,
    DEFAULT_LEGAL_OPERATOR_REGISTER_ID,
  );
  const LEGAL_VAT_ID = normalizeEmail(
    config.public.legalVatId as string | undefined,
    DEFAULT_LEGAL_VAT_ID,
  );
  const LEGAL_MANAGING_DIRECTOR = normalizeEmail(
    config.public.legalManagingDirector as string | undefined,
    DEFAULT_LEGAL_MANAGING_DIRECTOR,
  );
  const LEGAL_PHONE = normalizeEmail(
    config.public.legalPhone as string | undefined,
    DEFAULT_LEGAL_PHONE,
  );
  const LEGAL_SUPERVISORY_AUTHORITY = normalizeEmail(
    config.public.legalSupervisoryAuthority as string | undefined,
    DEFAULT_LEGAL_SUPERVISORY_AUTHORITY,
  );
  const LEGAL_PRIVACY_EMAIL = normalizeEmail(
    config.public.legalPrivacyEmail as string | undefined,
    DEFAULT_LEGAL_PRIVACY_EMAIL,
  );
  const LEGAL_COURT_PLACE = normalizeEmail(
    config.public.legalCourtPlace as string | undefined,
    DEFAULT_LEGAL_COURT_PLACE,
  );

  return {
    APP_URL,
    SITE_URL,
    SUPPORT_EMAIL,
    CONTACT_EMAIL,
    LEGAL_EMAIL,
    LEGAL_PLATFORM_NAME,
    LEGAL_OPERATOR_NAME,
    LEGAL_OPERATOR_ADDRESS,
    LEGAL_OPERATOR_CITY,
    LEGAL_OPERATOR_REGISTER_ID,
    LEGAL_VAT_ID,
    LEGAL_MANAGING_DIRECTOR,
    LEGAL_PHONE,
    LEGAL_SUPERVISORY_AUTHORITY,
    LEGAL_PRIVACY_EMAIL,
    LEGAL_COURT_PLACE,
  };
}
